import { CSSProperties, useEffect, useState } from "react";
import { Input } from "@/shared/ui/input/Input";
import { SelectedMui } from "@/shared/ui/selected/SelectedMui";
import { CoursesModel } from "@/entities/course/schema/schema";
import { CoursesModalList } from "@/widgets/courses/courses-modal-list/CoursesModalList";
import CatalogSvg from "../../../../public/assets/svg/catalog-book-directory.svg";
import { coursesStore } from "@/entities";

import styles from "./UserCoursesAddList.module.scss";

type Props = {
  term: string[];
  valueTerm: string;
  changeTerm: (value: number) => void;
  price: string;
  changePrice: (value: string) => void;
  changeCourseId: (value: number) => void;
  error: string;
  selectCourse: CoursesModel | null;
  handleselectCourse: (course: CoursesModel) => void;
  disabledIds?: number[];
  initCourseId?: number
};

const UserCoursesAddList = ({
  term,
  changePrice,
  price,
  valueTerm,
  changeTerm,
  changeCourseId,
  error,
  handleselectCourse,
  selectCourse,
  disabledIds,
  initCourseId,
}: Props) => {
  const [isOpenCourses, setIsOpenCourse] = useState<boolean>(false);
  const coursesList = coursesStore((state) => state.coursesList);
  const [isInitMatched, setIsInitMatched] = useState(false);

  const handleClickModalItem = (value: {
    id: number;
    title: string;
    description: string;
    img: string;
  }) => {
    const findCurrentCourse = coursesList.find((item) => item.id === value.id);
    if (!findCurrentCourse) return;
    changeCourseId(findCurrentCourse.id);
    handleselectCourse(findCurrentCourse);
    setIsOpenCourse(false);
  };

  const getCourseSelectStyles = (): CSSProperties => {
    if (isInitMatched) {
      return {
        opacity: '50%',
        cursor: 'not-allowed'
      }
    }
    if (error) {
      return { borderColor: "red" }
    }
    else return {}
  }

  const getInitSelectedCourse = () => {
    if (initCourseId) {
      const initSelectedCourse = coursesList.find((item) => item.id === initCourseId)
      if (initSelectedCourse) {
        handleselectCourse(initSelectedCourse)
        changeCourseId(initSelectedCourse.id)
        setIsInitMatched(true)
      }
    }
  }

  const handleClick = () => {
    !isInitMatched && setIsOpenCourse(true)
  }

  useEffect(() => {
    getInitSelectedCourse()
  }, [initCourseId])


  return (
    <>
      <CoursesModalList
        disabledIds={disabledIds}
        clickModalItem={handleClickModalItem}
        isOpen={isOpenCourses}
        closeModal={() => setIsOpenCourse(false)}
      />

      <div
        key={selectCourse ? selectCourse.id : 0}
        className={styles.cursesLine}
      >
        <div
          style={getCourseSelectStyles()}
          onClick={handleClick}
          className={styles.cursesLineLeftSide}
        >
          <button type="button" className={styles.catalogButton}>
            <CatalogSvg className={styles.catalogSvg} />
          </button>
          <div
            className={
              !selectCourse
                ? `${styles.customSelectCourses} ${styles.opasity}`
                : styles.customSelectCourses
            }
            style={error ? { opacity: 1 } : {}}
          >
            <p
              className={
                error
                  ? `${styles.coursesNameText} ${styles.error}`
                  : styles.coursesNameText
              }
            >
              {selectCourse ? selectCourse.name : "Выберите курс *"}
            </p>
          </div>
        </div>
        <div className={styles.cursesLineRightSide}>
          <SelectedMui
            label="Срок доступа"
            menuList={term}
            name="term"
            onChange={(e) =>
              changeTerm(term.findIndex((item) => item === e.target.value))
            }
            value={valueTerm}
          />
          <Input
            name="cost"
            label="Стоимость"
            value={price}
            onChange={(value) => changePrice(value)}
            type="number"
          />
        </div>
      </div>
    </>
  );
};

export { UserCoursesAddList };
